module.exports = __webpack_public_path__ + "772e12ab5376a940a1c877ec870912cf.png";